import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function WhoItsForSection() {
  const t = useT().whoItsFor;
  return <Section hasOrb={false} data-id="element-233">
      <Kicker data-id="element-234">{t.kicker}</Kicker>
      <H2 data-id="element-235">{t.title}</H2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16 mb-12" data-id="element-236">
        {t.cards.map((arch, i) => <Card key={i} delay={i * 0.1} className="flex items-start gap-4" data-id="element-237">
            <div className="w-3 h-3 rounded-full bg-brand mt-2 shrink-0 shadow-glow" data-id="element-238" />
            <div data-id="element-239">
              <h3 className="font-archivo text-xl uppercase tracking-tight mb-2" data-id="element-240">
                {arch.title}
              </h3>
              <p className="text-ink-dim" data-id="element-241">{arch.desc}</p>
            </div>
          </Card>)}
      </div>

      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.01
    }} transition={{
      delay: 0.4
    }} className="text-ink-dim text-center max-w-2xl mx-auto italic" data-id="element-242">
        {t.note}
      </motion.p>
    </Section>;
}